import { NgModule } from '@angular/core';
import { DefinitionsFacade } from '~/modules/definitions/domain/definitions.facade';
import { CommonModule } from '@angular/common';

@NgModule({
  imports: [CommonModule],
  providers: [DefinitionsFacade],
})
export class DefinitionsDomainModule {}
